module.exports = __webpack_public_path__ + "196712fcabc0f30781ec9547d8473a0c.pdf";